function paymentOptionsForPlan(currentPlan) {
  return [
    {
      type: "pastDue",
      description: "past due",
      value: currentPlan.pastDueAmount
    },
    {
      type: "monthly",
      description: "monthly payment amount",
      value: currentPlan.monthlyAmountDue
    },
    {
      type: "total",
      description: "remaining balance",
      value: currentPlan.totalDueAmount
    },
    {
      type: "other",
      description: "other amount",
      value: null
    }
  ];
}

export { paymentOptionsForPlan };



// WEBPACK FOOTER //
// ./src/shared/components/payment-options.js